const _resizeCanvas = (domElement, stage, iw, ih, size) => {
    //
    const w = size.width,
        h = size.height;
    const pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = Math.min(xRatio, yRatio);

    domElement.width = w * pRatio * sRatio;
    domElement.height = h * pRatio * sRatio;
    domElement.style.width = w * sRatio + 'px';
    domElement.style.height = h * sRatio + 'px';
    stage.scaleX = pRatio * sRatio;
    stage.scaleY = pRatio * sRatio;

    stage.tickOnUpdate = false;
    stage.update();
    stage.tickOnUpdate = true;
};

const _render = (stage, dt) => {
    stage.update({
        delta: dt,
        target: stage
    });
    return stage;
};

export const CreateJSInstance = pack => {
    const size = {
        width: pack.getWidth(),
        height: pack.getHeight()
    };
    const domElement = document.createElement('CANVAS');

    const lib = pack.getLibrary();
    const stage = new lib.Stage(domElement);

    const mc = pack.createMainView();
    mc.parent = stage;

    stage.addChild(mc);

    return {
        domElement,
        stage,
        mainView: mc,
        resizeMainView: pack.resizeMainView,
        resizeCanvas: (w, h) => _resizeCanvas(domElement, stage, w, h, size),
        render: dt => _render(stage, dt)
    };
};

export default CreateJSInstance;
